import { readAnalyticsEmbed } from "@/api";
import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { useAuth } from "@/contexts/auth/useAuth";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Navigate } from "react-router";
import { StatsDashboard } from "./components/StatsDashboard";

const AdminHome = () => {
    const { user } = useAuth();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Home");

    const { data: embed } = useSuspenseQuery({
        queryKey: ["admin-analytics-embed"],
        queryFn: readAnalyticsEmbed,
    });

    useMountEffect(() => {
        setBreadcrumbs([]);
    });

    if (!user) return <Navigate to="/login" replace />;

    if (!embed.dashboard_url) return <StatsDashboard user={user} />;

    return (
        // The subtracted height must equal AdminLayout's content padding at
        // each breakpoint, or 100cqh overflows the scrollport.
        <AdminPageContent className="flex h-[calc(100cqh-2rem)] flex-col gap-6 md:h-[calc(100cqh-3rem)]">
            <AdminPageHeader
                title="App Stats"
                subtitle="Product analytics for the last 30 days"
            />
            {/* The literal is PostHog's own page background, sampled from the
            embed. Matching it keeps the padding reading as part of the
            dashboard instead of banding against our cooler surface. */}
            <div className="border-border min-h-0 flex-1 overflow-hidden rounded-lg border bg-[#F3F4F0] p-4">
                <iframe
                    title="Last 30 days app stats"
                    src={embed.dashboard_url}
                    className="h-full w-full"
                    allowFullScreen
                    sandbox="allow-scripts allow-same-origin allow-popups"
                />
            </div>
        </AdminPageContent>
    );
};

export default AdminHome;
